import type { FaireProductEntity } from "../../entity_types/product";

export const p_g75876c6sy: FaireProductEntity = {
  token: "p_g75876c6sy",
  type: "product",
  name: 'Straight Sided Modern Mug-4"H(16oz)',
  brandToken: "b_a8n58zvndo",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.faire.com/fastly/4b06d7f9f5ee0766a8baf8317e94d30e154143005504badd6f9a88451c2bea91.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/42b8479378b914e8b9549bf931639459635a3f165ddbf903a70a1f9166394df6.jpeg",
    "https://cdn.faire.com/fastly/caba1fed3b63240c998b5379a2084a6de82dd14e23bf89d82de6d186c057dc8d.jpeg",
    "https://cdn.faire.com/fastly/227b9558205e4eac077c1d99bec2717eb063ef370f0ee77c768575c7ca00e671.jpeg",
    "https://cdn.faire.com/fastly/37495c25059b7bc7a631c7c9c0019f195cce327509f6a128b527f98b2702abe9.jpeg",
    "https://cdn.faire.com/fastly/4137ddc637c6dd5d8bc4fd3b3f742b973e73e9d5e99215f3334af2b94c0e154c.jpeg",
    "https://cdn.faire.com/fastly/1f9c2cab3080790703baf33fdc2166360d6d67b62667d0829d19928d13bc8f16.jpeg",
    "https://cdn.faire.com/fastly/786798ef88b3e2288ebae55a66d939d544c68913a5ecc8bbc2253bce651785f4.jpeg",
    "https://cdn.faire.com/fastly/e979a0f7bf052473343aff3b9998331b9845f28566cfe8f66a9f5902569f9240.jpeg",
    "https://cdn.faire.com/fastly/6af248a64dd365caa950f4b6921fd2ddb1db42b9fe82c74ab7dadea5f14be3e0.jpeg",
    "https://cdn.faire.com/fastly/1d824bd78ef11678e074ac743e27fc40299f5fc0a631ba69eb766811cd0be0ee.jpeg",
    "https://cdn.faire.com/fastly/5e5f85b619fc627f8546c6e016fac511b406273b417188d84881e57c067329ce.jpeg",
    "https://cdn.faire.com/fastly/8e5afaa373b71717d7e33838570526c75e03f0aae181110d8678753144a09310.jpeg",
    "https://cdn.faire.com/fastly/b12f6484210946c09aed78fc2c83eacc98687614e2cc466b14c44af9402c8961.jpeg",
    "https://cdn.faire.com/fastly/98a1f32395abc078468213d719077b5781ec0554b91c24e9af7f9a44c8d0bfae.jpeg",
    "https://cdn.faire.com/fastly/137c041be21a990ab0f65cac659d75d3b590014914d086e55e0c354fd292d164.jpeg",
    "https://cdn.faire.com/fastly/7b386f2fdc11a976db4776a96a3c8893fce21302dbfbb809dca2c02bd1730cba.jpeg",
    "https://cdn.faire.com/fastly/e52ec8303e8854567760a886f8764561bf9b2050e923a04681a615c5973ec3c3.jpeg",
    "https://cdn.faire.com/fastly/852d25d5e14d75954b829284217e114c14ef3efa7cd559ab4ebfa455a37a194e.jpeg",
  ],
  priceDollars: 8,
  description:
    "This glass mug is designed with straight sides and a smooth finish for a clean, modern look. Suitable for both hot and cold beverages, it is a versatile piece for contemporary kitchen collections.",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T19:58:06.171Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
